import { useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useLayerHost } from '@voll-intelligence/ui-kit/ui/screen-dialog';
import type { FlightDetailSummary } from '../../details/flight_detail_panel.js';

/** O detalhe de um voo que a lista ou a tela de tarifas pede ao host. */
export type FlightDetailRequest = {
  readonly offerId: string;
  readonly summary: FlightDetailSummary;
  /** Por qual porta o detalhe abriu: `seats` rola até o mapa de assentos. */
  readonly focus?: 'seats';
};

/** O drawer de detalhe do voo é do host (#4997): as pernas, o enriquecimento e
 *  o mapa de assentos vêm das portas dele. O kit decide QUANDO e ONDE monta. */
export type RenderFlightDetail = (detail: FlightDetailRequest, onClose: () => void) => ReactNode;

/**
 * O detalhe aberto e o nó dele, montado por portal na camada certa: dentro de
 * uma tela em diálogo, no popup dela (fora dele o Base UI deixa tudo inerte);
 * fora, no `body`. O portal sai da raiz `.genui2` do host, e as custom
 * properties do DS só herdam por ancestral — daí a classe no wrapper.
 */
export function useDetailLayer(render: RenderFlightDetail): {
  readonly detail: FlightDetailRequest | null;
  readonly open: (detail: FlightDetailRequest) => void;
  readonly node: ReactNode;
} {
  const host = useLayerHost();
  const [detail, setDetail] = useState<FlightDetailRequest | null>(null);
  const node =
    detail &&
    createPortal(
      <div className="genui2">
        {render(detail, () => {
          setDetail(null);
        })}
      </div>,
      host,
    );
  return { detail, open: setDetail, node };
}
